import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const MobileToolbarUndoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={26}
        height={26}
        viewBox="0 0 26 26"
        className="Icon mobile-toolbar-undo"
        {...props}
    >
        <path
            fill="#5F6672"
            d="M7.258 8.623a.542.542 0 0 1-.88.423L2.37 5.84a.542.542 0 0 1 0-.846l4.008-3.207a.542.542 0 0 1 .88.423v2.394h5.958c5.294 0 9.602 4.219 9.747 9.477l.003.273a9.75 9.75 0 0 1-9.75 9.75H9.425a.813.813 0 0 1 0-1.625h3.791a8.125 8.125 0 1 0 0-16.25H7.258v2.394z"
        />
    </svg>
);
const Memo = memo(MobileToolbarUndoIcon);
export default Memo;
